export const navLinks = [
  { href: '#bloqueos', label: 'Qué revisamos' },
  { href: '#incluye', label: 'Qué incluye' },
  { href: '#para-quien', label: 'Para quién es' },
]

export const triedThings = [
  'Vas al gym',
  'Intentas comer mejor',
  'Haces cardio',
  'Compraste proteína',
  'Buscas rutinas en internet',
  'Tratas de ser constante',
]

export const suspects = ['tu comida', 'tu entrenamiento', 'tu horario', 'tu falta de músculo', 'tu metabolismo', 'tu cardio']

export const blockers = [
  { icon: 'flame', title: 'Grasa que no baja', text: 'Revisamos por qué podrías estar estancado/a aunque estés intentando comer mejor o entrenar.' },
  { icon: 'dumbbell', title: 'Falta de músculo o definición', text: 'Vemos si tu entrenamiento realmente está ayudando a construir músculo o si solo estás sudando sin dirección.' },
  { icon: 'shuffle', title: 'Rutina desorganizada', text: 'Detectamos si estás cambiando ejercicios, copiando rutinas o entrenando sin una progresión clara.' },
  { icon: 'utensils', title: 'Alimentación confusa', text: 'Analizamos si tu comida está alineada con tu objetivo o si estás comiendo “saludable” sin estrategia.' },
  { icon: 'clock', title: 'Falta de tiempo', text: 'Tomamos en cuenta tu realidad: trabajo, horarios largos, familia, cansancio y vida en Estados Unidos.' },
  { icon: 'chart', title: 'Falta de seguimiento', text: 'Vemos si necesitas más estructura, ajustes y dirección para no seguir adivinando.' },
] as const

export const realityTags = ['Muchas horas de trabajo', 'Comes rápido', 'A veces comes fuera', 'Sales cansado/a', 'Familia', 'Responsabilidades', 'Poco tiempo']

export const includes = [
  { title: 'Análisis de tu punto actual', text: 'Revisamos tu objetivo, peso, experiencia, horario, nivel de actividad y lo que ya has intentado.' },
  { title: 'Revisión de entrenamiento', text: 'Vemos si tu rutina actual tiene dirección, progresión y sentido para tu objetivo.' },
  { title: 'Revisión de alimentación', text: 'Identificamos si tu forma de comer está ayudando o frenando tu pérdida de grasa, recomposición o ganancia muscular.' },
  { title: 'Próximo paso claro', text: 'Sales con una idea más clara de qué deberías cambiar primero para dejar de improvisar.' },
]

export const resultOutcomes = [
  'Menos grasa corporal.',
  'Más definición y forma.',
  'Más fuerza y confianza.',
  'Mejor relación con la comida.',
  'Más claridad dentro y fuera del gym.',
]

export const forYou = [
  'Vives en Estados Unidos y quieres mejorar tu físico.',
  'Quieres perder grasa, bajar barriga o verte más definido/a.',
  'Quieres ganar músculo o mejorar la forma de tu cuerpo.',
  'Vas al gym pero no sabes si estás haciendo lo correcto.',
  'Comes “más saludable” pero no ves el cambio que esperas.',
  'Trabajas mucho y necesitas algo realista.',
  'Te cuesta mantener la constancia.',
  'Quieres orientación en español.',
  'Estás cansado/a de probar cosas sin una dirección clara.',
]

export const notForYou = [
  'Buscas una solución mágica sin hacer cambios.',
  'Solo quieres una dieta extrema de pocos días.',
  'No estás dispuesto/a a hablar honestamente sobre tus hábitos.',
  'Quieres seguir improvisando sin recibir guía.',
  'No estás interesado/a en mejorar tu cuerpo de forma seria.',
]

export const stuckLoop = ['Entrenan un poco', 'Hacen cardio', 'Comen menos algunos días', 'Ven videos', 'Cambian rutinas', 'Se pesan', 'Se frustran', 'Vuelven a empezar']

